import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigFacadeService } from '@core/services/config/config-facade.service';
import { GenericMessage } from '@app/interfaces/globals';
import { makeUri } from '@utils/string.tool';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class BillingService {
	constructor(private _http: HttpClient, private appConfig: ConfigFacadeService) {}

	getBillDetails(id: string, date: string): Observable<any> {
		const url = makeUri(this.appConfig.config.apiUrl, 'billing/get_bill_details');
		return this._http.post<GenericMessage>(url, { id, date });
	}

	approveBill(name: string, bill_data: any[]): Observable<any> {
		const url = makeUri(this.appConfig.config.apiUrl, 'billing/approve_bill');
		return this._http.post<GenericMessage>(url, { name, bill_data });
	}

	downloadDetailedReport(org_id: string, date: string, reseller_id: string = null): Observable<any> {
		const url = makeUri(this.appConfig.config.apiUrl, 'billing/get_detailed_report');
		return this._http.post<GenericMessage>(url, { org_id, date, reseller_id });
	}
}
